import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryCollections } from '@wix/ambassador-portfolio-collections-v1-collection/http';
export const fetchPortfolioCollections = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const chunkCollections = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    for (const idChunk of idChunks) {
      const {
        data: {
          collections
        }
      } = await httpClient.request(queryCollections({
        query: {
          filter: idChunk.length > 0 ? {
            id: {
              $in: idChunk
            }
          } : undefined,
          paging: {
            limit: COMMON_PAGE_LIMIT,
            offset: 0
          }
        }
      }));
      chunkCollections.push(...(collections ?? []));
    }
  }, {
    errorCodesMap: {}
  });
  return chunkCollections;
};
//# sourceMappingURL=fetch-portfolio-collections.js.map